<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('homework.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homework.pageTitle'),
            href: '/homeworks'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <staff-homework-edit v-if="isStaff" />
    <teacher-homework-edit v-if="isTeacher" />
  </div>
</template>
<script>
import StaffHomeworkEdit from './staff/edit'
import TeacherHomeworkEdit from './teacher/edit'
import store from '@/store'

export default {
  name: 'homeworkEdit',
  components: {
    StaffHomeworkEdit,
    TeacherHomeworkEdit
  },
  data() {
    return {}
  },
  computed: {
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isTeacher() {
      return this.$store.getters.isTeacherLogin
    }
  },
  methods: {},
  beforeRouteEnter: async (to, from, next) => {
    if (store.getters.isStaffLogin) {
      await store.dispatch('eschool/staffHomework/find', to.params.id)
    }
    if (store.getters.isTeacherLogin) {
      await store.dispatch('eschool/teacherHomework/find', to.params.id)
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('eschool/staffHomework/SET_EDIT_DATA', {})
    this.$store.commit('eschool/teacherHomework/SET_EDIT_DATA', {})
    next()
  }
}
</script>
